// extracted by mini-css-extract-plugin
export var postGrid = "s_bc";
export var wpPageLayout = "s_bb";
export var wpPageRelatedGrid = "s_bd";
export var wpPageRoot = "s_9";